import { render, staticRenderFns } from "./aboutUs.vue?vue&type=template&id=4f550642&scoped=true&"
import script from "./aboutUs.vue?vue&type=script&lang=js&"
export * from "./aboutUs.vue?vue&type=script&lang=js&"
import style0 from "./aboutUs.vue?vue&type=style&index=0&id=4f550642&prod&lang=scss&scoped=true&"
import style1 from "./aboutUs.vue?vue&type=style&index=1&id=4f550642&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f550642",
  null
  
)

export default component.exports